var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('load-spinner',{attrs:{"loading":_vm.isLoading}}),_vm._v(" "),_c('p',[_vm._v("Current Group: "+_vm._s(_vm.student.cgroup))]),_vm._v(" "),_c('FullCalendar',{attrs:{"options":_vm.calendarOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }